//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from 'moment';
export default {
  name: '127.0.0.1Modal',
  data: function data() {
    return {
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 4
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 20
        }
      },
      confirmLoading: false,
      dates: [],
      form: this.$form.createForm(this),
      url: {
        add: '/comm/api/rpc'
      }
    };
  },
  created: function created() {},
  methods: {
    moment: moment,
    edit: function edit(record) {
      this.dates = [];
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
    },
    onDateChange: function onDateChange(value, dateString) {
      this.model.beginTime = dateString[0] == '' ? null : dateString[0];
      this.model.endTime = dateString[1] == '' ? null : dateString[1];
    },
    close: function close() {
      this.form.resetFields();
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err && _this.model.endTime && _this.model.beginTime) {
          that.confirmLoading = true;
          var httpurl = '';
          var method = '';

          if (!_this.model.id) {
            httpurl += _this.url.add;
            method = 'post';
          } else {
            httpurl += _this.url.edit;
            method = 'put';
          }

          var formData = Object.assign(_this.model, values); //时间格式化
          // formData.beginTime = formData.beginTime ? formData.beginTime.format('YYYY-MM-DD HH:mm:ss') : null
          //formData.endTime = formData.endTime ? formData.endTime.format('YYYY-MM-DD HH:mm:ss') : null

          _this.$confirm({
            title: '你确定要开始数据补登操作吗?',
            content: '提示信息',
            onOk: function onOk() {
              that.confirmLoading = true;
              httpAction(httpurl, formData, method).then(function (res) {
                if (res.success) {
                  that.$notification.success({
                    message: res.message
                  });
                  that.$emit('ok');
                  that.close();
                } else {
                  that.$notification.warning({
                    message: res.message
                  });
                }
              }).finally(function () {
                that.confirmLoading = false;
              });
            },
            onCancel: function onCancel() {}
          });
        } else {
          that.$message.warning('时间和命令不能为空');
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    }
  }
};